// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3z4ZQ","file":"styles_file__18G5V"};